export const CBOX_OPTIONS = {
  maxWidthLg: '800px',
  maxHeightLg: '800px',
  maxWidthMd: '800px',
  maxHeightMd: '200px',
  maxWidthSm: '800px',
  maxHeightSm: 'auto'
};
export const TABLET_MIN_WIDTH = 768;
export const DESKTOP_MIN_WIDTH = 1367;
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const ERROR = 'ERROR';
export const CHOOSE_ALTERNATE_PRODUCT = '1003';
export const SMS_POPUP_HEIGHT = '100%';

export const colorBoxCloseIdText = 'cboxClose';

export const FROM_NO_PAYER = 'fromNoPayer';
export const FROM_INSURANCE_VIEW = 'fromInsuranceView';
export const FROM_ERROR_TILE = 'fromErrorTile';

export const resolveAddSelectDoctor = '1008';
export const PAY_OUT_OF_POCKET = '1000';
export const REMOVE = '1006';
export const ADD_DIAGNOSIS_CHECKOUT = '1011';
export const RECONFIRM_SIGINING_PHYSICIAN = '1020';
export const DELIVERED = 'DELIVERED';
export const SHIPPED = 'SHIPPED';
export const PENDED = 'PENDED';
export const CANCELLED = 'cancelled';

export const EXPIRED_INSURANCE = '108';

export const PPS_IN_HOSPITAL_LAST_60DAYS_YES = 'PPSA1';
export const PPS_IN_HOSPITAL_DISCHARGE_YES = 'PPSA3';
export const PPS_IN_HOSPITAL_DISCHARGE_NO = 'PPSA4';
export const PPS_IN_SKILLED_NURSERY_YES = 'PPSA6';
export const PPS_IN_SKILLED_NURSERY_NO = 'PPSA7';

export const SMS_ENROLLMENT_OPTOUT = { key: 'OPTOUT', value: 'Opted Out ' };
export const SMS_ENROLLMENT_NOTENROLLED = {
  key: 'NOTENROLLED',
  value: 'Not Enrolled'
};
export const SMS_ENROLLMENT_PENDING = { key: 'PENDING', value: 'Pending' };
export const SMS_ENROLLMENT_ACTIVE = { key: 'Enrolled', value: 'Enrolled' };
export const SMS_ENROLLMENT_NORESPONSE = {
  key: 'NORESPONSE',
  value: 'No Response'
};

export const DATE_FORMAT = 'mm/dd/yy';
